import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'

function List(props) {
  const { list, onGenerateCSV, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'BAS Code',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <a
          onClick={() => {
            onShow(original, 'edit')
          }}>
          {value}
        </a>
      ),
    },
    { Header: 'Company', accessor: 'company.fn' },
    { Header: 'Start Date', accessor: 'start' },
    { Header: 'End Date', accessor: 'end' },
    // {Header: 'Title', accessor: 'title'},
    { Header: 'Currency', accessor: 'currency' },
    { Header: 'Tax Liability', accessor: 'taxLiability' },
    { Header: 'Status', accessor: 'status' },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
